import * as React from 'react';
import { Button } from "primereact/button";
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { ActiveIngredientAdminModel } from "../../../models/activeIngredient";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import getInteractionSeverity from './interactionsSeverityFunctions';
import { DrugToDrugInteractionModel } from "../../../models/activeIngredient";
import { Lang } from '../../../common/enums';
import { DrugInteractionContentModel } from '../../../models/activeIngredient/drugInteractionContentModel';
import * as HelperFunctions from '../../../common/functions/helperFunctions';

interface IProps {
  activeIngredient: ActiveIngredientAdminModel
  removeDrugInteractionClick: any,
  setIsVisibleDrugAddEditInteractionDialog: any,
  onAddEditDrugInteractionClick: any
  setIsActiveIngredientDropdownDisabled: any
}

interface IState {
  validationMessage: string;
}

class ActiveIngredientTabDrugInteraction extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      validationMessage: ''
    };
  }

  handleDrugAddEditClick = (interactionIngredientId, selectedIngredientId) => {
    if (!interactionIngredientId) { // Add		
      let newDrugInteraction = new DrugToDrugInteractionModel();
      newDrugInteraction.selectedIngredientId = selectedIngredientId;

      let contentList = new Array<DrugInteractionContentModel>(0);
      const langKeys = HelperFunctions.getEnumKeys(Lang);

      langKeys.map(k => {
        let content = new DrugInteractionContentModel();
        content.langId = parseInt(Lang[k]);
        content.professionalDecscription = '';
        content.consumerDecscription = '';
        contentList.push(content);
      });

      newDrugInteraction.drugToDrugInteractionContent = contentList;

      this.handleDrugInteractionAddEditClick(newDrugInteraction, false);
    } else {
      let currentDrugInteraction = this.props.activeIngredient.drugToDrugInteractions.
        find(f => f.interactionIngredientId === interactionIngredientId && f.selectedIngredientId === selectedIngredientId);
      if (currentDrugInteraction) {
        this.handleDrugInteractionAddEditClick(currentDrugInteraction, true);
      }
      else {
        this.setState({
          validationMessage: 'Erorororororo'
        });
      }
    }
  }

  handleDrugInteractionAddEditClick(drugInteraction: DrugToDrugInteractionModel, isDisabled: boolean) {
    this.props.onAddEditDrugInteractionClick(drugInteraction)
    this.props.setIsVisibleDrugAddEditInteractionDialog(true);
    this.props.setIsActiveIngredientDropdownDisabled(isDisabled);
  }

  public render() {

    const { activeIngredient } = this.props;
    const currentActiveIngredientId = this.props.activeIngredient.activeIngredientId ? this.props.activeIngredient.activeIngredientId : -1;

    return (

      <div style={{ minHeight: '550px', maxHeight: '650px' }}>
        {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
        <div className="p-grid p-md-12">
          <div className="p-col-12 p-md-12">
            <div className="mb-2">
              <button
                onClick={() => this.handleDrugAddEditClick(null, currentActiveIngredientId)}
                className="btn btn-success"
                style={{ marginRight: "5px" }}>
                Add New
									</button>
            </div>
            <DataTable
              value={activeIngredient.drugToDrugInteractions}
              dataKey='interactionIngredientId'
            >
              <Column
                header="Name"
                field="interactionIngredientName" />
              <Column
                header="Interaction severity"
                field="interactionTypeId"
                body={(rowData, column) =>
                  <div>
                    {getInteractionSeverity('iconLabel', rowData.interactionTypeId)}
                  </div>}
              />
              <Column
                header="Actions"
                style={{ textAlign: "center", width: "8em" }}
                body={(rowData, column) =>
                  <div>
                    <Button
                      type="button"
                      icon="pi pi-pencil"
                      className="p-button-warning"
                      tooltip="Edit"
                      tooltipOptions={{ position: 'top' }}
                      style={{ marginRight: ".5em" }}
                      onClick={() => this.handleDrugAddEditClick(rowData.interactionIngredientId, rowData.selectedIngredientId)}
                    />
                    <Button
                      type="button"
                      icon="pi pi-trash"
                      className="p-button-danger"
                      tooltip="Remove"
                      tooltipOptions={{ position: 'top' }}
                      onClick={() => this.props.removeDrugInteractionClick(rowData.selectedIngredientId, rowData.interactionTypeId, rowData.interactionIngredientId)}
                    />
                  </div>
                }
              />
            </DataTable>
          </div>
        </div>
      </div>
    )
  }
}

export default ActiveIngredientTabDrugInteraction;